<app-navigation></app-navigation>
<div class="app-shell">
  <main #routeStage class="route-stage">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
<button
  class="scroll-top"
  type="button"
  [class.is-visible]="showScrollToTop"
  [attr.aria-hidden]="!showScrollToTop"
  [attr.tabindex]="showScrollToTop ? 0 : -1"
  aria-label="Revenir en haut de la page"
  (click)="scrollToTop()"
>
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 20V4m-6 6 6-6 6 6" />
  </svg>
</button>
